/* eslint-disable import/no-cycle */
import React from 'react';
import PropTypes from 'prop-types';
import { NumberInput } from '@mantine/core';

const WsQuantitySelectorBlock = ({
  quantity,
  onQuantityChange,
  submitting,
  config,
  ecomStoreProduct,
  ecomStoreCart,
  selectedVariants,
  isBundleProduct,
  isUnavailable
}) => {
  const quantityLeft = !isBundleProduct
    ? selectedVariants[0]?.ecomVendorProductVariant.quantity
    : null;
  const outOfStock = quantityLeft !== null && quantityLeft <= 0;
  const productInCartCount = isBundleProduct
    ? 0
    : ecomStoreCart?.ecomStoreCartProducts
        .filter(
          (p) =>
            p.ecomStoreProductVariant.ecomVendorProductVariant.uuid ===
            selectedVariants[0]?.ecomVendorProductVariant.uuid
        )
        ?.reduce((acc, p) => acc + p.count, 0) || 0;
  const maxQuantity =
    !isBundleProduct && selectedVariants[0]?.ecomVendorProductVariant.quantity
      ? selectedVariants[0].ecomVendorProductVariant.quantity -
        productInCartCount
      : null;

  return (
    <NumberInput
      disabled={submitting || isUnavailable || outOfStock}
      label={`Quantity ${
        productInCartCount ? `(${productInCartCount} in cart)` : ''
      }`}
      min={1}
      onChange={(value) => {
        let newQuantity =
          maxQuantity !== null && value > maxQuantity ? maxQuantity : value;
        if (newQuantity <= 0) {
          newQuantity = 1;
        }
        onQuantityChange(newQuantity);
      }}
      radius={0}
      size="sm"
      style={{ maxWidth: 150 }}
      styles={{
        label: {
          fontSize: 14,
          // color: textColorVariants.lighter,
          fontWeight: 500
        }
      }}
      value={quantity}
    />
  );
};

WsQuantitySelectorBlock.propTypes = {
  config: PropTypes.object,
  ecomStoreCart: PropTypes.object,
  ecomStoreProduct: PropTypes.object,
  isBundleProduct: PropTypes.bool,
  isUnavailable: PropTypes.bool,
  onQuantityChange: PropTypes.func,
  quantity: PropTypes.number,
  selectedVariants: PropTypes.array,
  submitting: PropTypes.bool
};

export default WsQuantitySelectorBlock;
